import { render } from "./nomination.vue?vue&type=template&id=1543e2ba&scoped=true"
import script from "./nomination.vue?vue&type=script&lang=ts"
export * from "./nomination.vue?vue&type=script&lang=ts"

import "./nomination.vue?vue&type=style&index=0&id=1543e2ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1543e2ba"

export default script